export class UserPromotion {
  activationDate: Date;
  expiryDate: Date;
  typeName: string;
  promotionData: {[key: string]: string};
  constructor(data: any) {
    this.typeName = data.typeName;
    this.expiryDate = data.expiryDate;
    this.activationDate = data.activationDate;
    this.promotionData = data.promotionData
      .map((item: DataItem) => ({[item.key]: item.value}))
      .reduce((acc: DataItem, curr: DataItem) => ({ ...acc, ...curr }), {});
  }
}
class DataItem {
  key: string;
  value: string;
  constructor(key: string, value: string) {
    this.key = key;
    this.value = value;
  }
}
